export default __webpack_public_path__ + "static/media/partner_img_03.34b5ff0f.svg";